module.exports = __webpack_public_path__ + "img/imgtui.e91d27a9.jpg";